import React from "react";
import { useTranslation } from "react-i18next";
import logoWithoutBackground from "../../../assets/images/Liifer_logo_full_max.png";
import { Link } from "react-router-dom";
import { useAppSelector } from "store/hooks";

export const FAQHeader: React.FC = () => {
  const { t } = useTranslation();
  const accessToken = useAppSelector((state) => state.auth.accessToken);

  return (
    <>
      <header className="bg-slate-800 md:h-24 flex items-center">
        <div className="text-slate-100 font-medium text-xl md:text-2xl lg:text-3xl text-center md:text-left flex flex-col md:flex-row w-full lg:mr-72 py-2 md:py-0">
          <div className="md:w-1/3">
            <div
              style={{ backgroundColor: "#171F38" }}
              className="flex flex-row rounded-full w-fit mx-auto md:mx-0 md:ml-8 xl:ml-10"
            >
              <Link
                to={!!accessToken ? "/dashboard/mymeals" : "/home"}
                className="hover:opacity-80 ease-in-out duration-200"
                draggable={false}
              >
                <img
                  className="h-9 m-3 mx-5"
                  src={logoWithoutBackground}
                  alt="Liifer Logo"
                />
              </Link>
            </div>
          </div>
          <div className="md:flex md:items-center lg:w-2/3 pt-4 md:pt-0 md:ml-10">
            {t("FAQ.headerTitle")}
          </div>
        </div>
      </header>
    </>
  );
};

export default FAQHeader;
